import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeroInternas } from "../heroInternas/HeroInternas";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import renderHTML from "react-render-html";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        border: 'none',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
        fontFamily: 'FuturaBold',
        fontSize: '16px',
        color: 'black'
    },
}));


export const ConoceFiatPlan = () => {
    const classes = useStyles();

    const [state, setstate] = useState([]);
    useEffect(() => {
        fetch("/conoce_plan")
            .then(res => res.json())
            .then(result => {
                if (result.estado !== 0) {
                    setstate(result);
                }
            });
    }, []);


    state.map(stat => {
        let desc = stat.descripcion.replaceAll("&nbsp;", " ");
        stat.newDescription = desc;
        console.log(stat);
    });


    console.log(state);

    return (
        <div className="flexible bg-gris">
            <HeroInternas clase='conoce' img='/images/internas/conoce-desktop.png' imgMobile='/images/internas/conoce-mobile.png'/>
            <div className="drop-container">
                <div className="drop">
                    {
                        state.map((stat, i) => (
                            <>
                                <div className={classes.root} key={stat.titulo}>
                                    <Accordion>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <Typography
                                                className={classes.heading}
                                            >
                                                {stat.titulo}
                                            </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography
                                                variant="h1"
                                                component="div"
                                            >
                                                <div>
                                                    {renderHTML(
                                                        stat.newDescription
                                                    )}
                                                </div>
                                            </Typography>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                                <div className="separator--hor"></div>
                            </>
                        ))}
                    <div className="d-flex flex-column justify-content-center align-items-center mt-base">
                        <p className="ff-FuturaMedium">Para más consultas podes visitar</p>
                        <Link to='/preguntas_frecuentes' className="text-decoration-none"><button className="btn-preguntas"><p className="ff-FuturaExtraBold">Preguntas frecuentes</p></button></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

